var _path, _path2, _line, _line2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEducation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 350,
    height: 240,
    viewBox: "0 0 350 240",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.4722 91.5L174.5 41.2678L309.528 91.5L174.5 141.732L39.4722 91.5Z",
    stroke: "currentColor",
    strokeWidth: 8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M78 105V171.5C78 180.598 84.1406 188.55 92.9431 190.85L110.359 195.402L123 197.599L138.859 199.201L166 199.499H193H214L235.5 197.599L250.5 195.7L262.521 193.586C263.506 193.413 264.476 193.166 265.424 192.848L269.367 191.523C277.512 188.788 283 181.156 283 172.564V105H275V172.564C275 177.719 271.707 182.298 266.82 183.94L262.877 185.264C262.308 185.455 261.726 185.603 261.135 185.707L249.304 187.788L234.645 189.644L213.647 191.499H193H166.043L139.305 191.205L124.088 189.669L112.058 187.577L94.9658 183.11C89.6844 181.73 86 176.959 86 171.5V105H78Z",
    fill: "currentColor"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 50,
    y1: 90,
    x2: 50,
    y2: 120,
    stroke: "currentColor",
    strokeWidth: 8
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 181,
    y1: 92,
    x2: 51,
    y2: 92,
    stroke: "currentColor",
    strokeWidth: 8
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64 167H62.1593H56H45H38.2275H37C37 136.624 43.0442 112 50.5 112C57.9558 112 64 136.624 64 167ZM45.1471 159H55.8529C55.4278 147.553 54.1097 137.485 52.2766 130.016C51.6971 127.656 51.0936 125.67 50.5 124.046C49.9064 125.67 49.3029 127.656 48.7234 130.016C46.8903 137.485 45.5722 147.553 45.1471 159ZM52.9884 119.169C52.9893 119.176 52.9463 119.227 52.8567 119.301C52.9427 119.199 52.9875 119.162 52.9884 119.169ZM48.1433 119.301C48.0537 119.227 48.0107 119.176 48.0116 119.169C48.0125 119.162 48.0573 119.199 48.1433 119.301Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEducation);
export default __webpack_public_path__ + "static/media/education.824ff5afb0ecbcbd51cd7ca9f2b8f7ed.svg";
export { ForwardRef as ReactComponent };